import { render, staticRenderFns } from "./ProjectCommissionPolicyView.vue?vue&type=template&id=ef53e960&"
import script from "./ProjectCommissionPolicyView.vue?vue&type=script&lang=js&"
export * from "./ProjectCommissionPolicyView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCommissionPolicyView.vue?vue&type=style&index=0&id=ef53e960&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports